import React, { Component } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Field, reduxForm, reset } from 'redux-form';
import { connect } from 'react-redux';
import { DateTimePicker } from 'material-ui-pickers';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import ModalWrapper from '../ModalWrapper';
import FormError from '../Form/FormError';
import {
  modalsToggle,
  addAuction,
  snackShow,
  getLocation,
  auctionsUnsetSuccess
} from '../../actions';
import { DATE_FORMAT_FULL, dayOfWeek } from '../../constants';

const validate = values => {
  const errors = {};
  ['date_start'].forEach(item => {
    if (!Object.prototype.hasOwnProperty.call(values, item)) {
      errors[item] = 'Required';
    }
  });
  return errors;
};

const formName = 'AuctionCreateModal';

const DatePickerField = ({ input: { onChange, value } }) => (
  <DateTimePicker
    label=""
    showTodayButton
    minDate={moment().format()}
    value={value || moment().format()}
    onChange={onChange}
    format={DATE_FORMAT_FULL}
  />
);

const styles = {
  spanLabel: {
    marginRight: 15
  },
  modalHolder: {
    maxWidth: 360
  }
};

class AuctionCreateModal extends Component {
  componentDidMount() {
    const { fetchLocation } = this.props;
    fetchLocation(1); // TODO - link to selected location
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.created) {
      const { toggleModal, showSnack, resetForm, unsetSuccess } = this.props;
      toggleModal(formName);
      resetForm(formName);
      showSnack({ message: 'Auction created' });
      unsetSuccess();
    }
  }

  submit = values => {
    const { createAuction } = this.props;
    createAuction(values);
  };

  render() {
    const {
      handleSubmit,
      submitting,
      formSubmitting,
      formError,
      classes,
      locationItem
    } = this.props;
    const spacingTime = (locationItem &&
      locationItem.end_time_spacing &&
      locationItem.end_time_spacing.split(':')) || [0, 0];
    return (
      <ModalWrapper
        title="Create New Auction"
        handleSubmit={handleSubmit(this.submit)}
        submitting={submitting || formSubmitting}
        modalId="newAuctionModal"
        contentClassName={classes.modalHolder}
      >
        <form onSubmit={this.handleSubmit}>
          <Grid container spacing={16} alignItems="center">
            {/* <Grid item xs={12} lg={6}>
              <Typography align="right" variant="body1">Location</Typography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Field
                name="location"
                component={FormSelect}
                margin="dense"
                placeholder="Prefered day of auction"
                fullWidth
              >
                {[].map((item, i) => (<MenuItem key={i} value={i}>{item}</MenuItem>))}
              </Field>
            </Grid> */}
            <Grid item xs={12} lg={12}>
              <span className={classes.spanLabel}>Start:</span>
              <Field
                name="date_start"
                component={DatePickerField}
                margin="dense"
                type="text"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <Typography>{`Auctions end ${
                dayOfWeek[locationItem.end_day]
              } at ${moment
                .utc(locationItem.end_time, 'HH:mm')
                .local()
                .format('hh:mm A')}`}</Typography>
              <Typography>{`Final Auction Shuffle - ${
                dayOfWeek[locationItem.shuffle_day]
              } at ${moment
                .utc(locationItem.shuffle_time, 'HH:mm')
                .local()
                .format('hh:mm A')}`}</Typography>
              <Typography>{`Spacing between end times - ${
                spacingTime[0]
              } mins, ${spacingTime[1]} seconds`}</Typography>
            </Grid>
          </Grid>
          {formError && <FormError msg={formError} />}
        </form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = state => ({
  formSubmitting: state.auctions.submitting,
  formError: state.auctions.error,
  created: state.auctions.success,
  locationItem: state.locations.singleItem || ''
});

const mapDispatchToProps = dispatch => ({
  toggleModal: key => dispatch(modalsToggle(key)),
  createAuction: data => dispatch(addAuction(data).request),
  showSnack: message => dispatch(snackShow(message)),
  resetForm: () => dispatch(reset(formName)),
  fetchLocation: id => dispatch(getLocation(id).request),
  unsetSuccess: () => dispatch(auctionsUnsetSuccess())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: formName,
    initialValues: {
      date_start: moment().format()
    },
    validate
  })(withStyles(styles)(AuctionCreateModal))
);
